import axios from 'axios';
import { api_url1 } from '../conf/conf';

/**
 * Получить список неоплаченных счетов юр. лиц
 * GET /legal/admin/pending-invoices
 */
export async function getPendingInvoices() {
    try {
        const response = await axios.get(`${api_url1}/legal/admin/pending-invoices`);
        console.log('getPendingInvoices response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error getting pending invoices:', error.response ? error.response.data : error.message);
        throw new Error('Ошибка при получении неоплаченных счетов');
    }
}

/**
 * Подтвердить оплату по счёту
 * POST /legal/admin/confirm-invoice
 */
export async function confirmInvoice(invoiceNumber) {
    try {
        const response = await axios.post(`${api_url1}/legal/admin/confirm-invoice`, {
            invoiceNumber
        });
        console.log('confirmInvoice response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error confirming invoice:', error.response ? error.response.data : error.message);
        throw error.response?.data || new Error('Ошибка при подтверждении оплаты');
    }
}

/**
 * Получить историю платежей юр. лица
 * GET /legal/payment/history?legalEntityId=
 */
export async function getLegalPaymentHistory(legalEntityId) {
    try {
        const response = await axios.get(`${api_url1}/legal/payment/history`, {
            params: { legalEntityId }
        });
        console.log('getLegalPaymentHistory response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error getting payment history:', error.response ? error.response.data : error.message);
        throw new Error('Ошибка при получении истории платежей');
    }
}
